<template>
  <v-layout wrap pa-3 >
    <v-flex sm12 px-2>
        <v-text-field clearable v-model="adminFilterSearch" :label="$t('Admin.Search')" append-icon="mdi-magnify" />                
      </v-flex>
      <v-flex sm6 pr-2>
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminUserEnseigneFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="id" :items="enseignes" :label="$t('Admin.User.List.FilterCompany')"></v-autocomplete>
      </v-flex>      
      <v-flex sm6 pl-2>
        <v-autocomplete :menu-props="{ closeOnClick: false, openOnClick: false }" hide-no-data browser-autocomplete="disable" dense small-chips deletable-chips hide-selected multiple v-model="adminUserRolesFilterIds" clearable clear-icon="mdi-close" item-text="libelle" item-value="ROL_KEY" :items="roles" :label="$t('Admin.User.List.FilterRole')"></v-autocomplete>
      </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbUser } from '@/models/alodb/AloDbUser';
import { FilterUser } from '@/models/filter/FilterUser';


@Component({
  name: 'AdminUserFilter'
})
export default class AdminUserFilter extends Vue {  
  
  //recupere les enseignes possédants au moins un utilisateur
  get enseignes() {
    return this.$store.myGetters.enseignes.filter(e => this.$store.myGetters.users.findIndex(u => u.ENS_ID == e.ENS_ID) > -1)    
  }

  get roles(){
    return this.$store.myGetters.roles.filter(r => this.$store.myGetters.users.some(u => u.ROLES?.some(ro => r.ROL_KEY)))    
  }
  
  get adminUserEnseigneFilterIds() {
    return this.$store.myGetters.adminUserFilter.enseigneIds
  }
  set adminUserEnseigneFilterIds(value) {
    this.$store.myActions.USER_UPDATE_FILTER_ADM({
      enseigneIds:value
    })
  }  

  get adminUserRolesFilterIds() {
    return this.$store.myGetters.adminUserFilter.roleKeys
  }
  set adminUserRolesFilterIds(value) {
    this.$store.myActions.USER_UPDATE_FILTER_ADM({
      roleKeys:value
    })
  }  

  get adminFilterSearch() {
    return this.$store.myGetters.adminUserFilter.search
  }
  set adminFilterSearch(value) {

    this.$store.myActions.USER_UPDATE_FILTER_ADM({
      search:value == null?"":value
    })
  } 

}
</script>
